import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
 
@Injectable({
  providedIn: 'root',
})
export class ActionPlanServices {
  private sendPositionSubject = new BehaviorSubject([]);

  private sendPositioObservable: Observable<any> = this.sendPositionSubject.asObservable();

  // eslint-disable-next-line
  constructor(private httpClient: HttpClient) {}

  getOperationNumber (isMyactionPlan) {
    return this.httpClient.get(environment.api.base + 'actionplan/GetActionPlanListByRole?isMyactionPlan=' + ((isMyactionPlan==true)?"SI":"NO"));
  }

  getActionPlanByOperationNumber(idActionPlan) {
    return this.httpClient.get(environment.api.base + 'actionplan/GetActionPlanListByAnalisisId?IdActionPlan='+idActionPlan);
  }

  getCloneActionPlan(actionPlanId) {
    return this.httpClient.put(environment.api.base + 'actionplan/CloneActionPlan?actionPlanId='+actionPlanId,{});
  }
  
  /*getExternalUserByMail(mail) {
    return this.httpClient.get(environment.api.base + 'ExternalUser/GetExternalUserByMail?mail='+mail);
  }*/

  upDateActionPlan(listActionPlan) {
    console.log('flag5');
    return this.httpClient.put(environment.api.base + 'actionplan',listActionPlan);
  }

  deleteCloneActionPlan(actionPlanId) {
    return this.httpClient.put(environment.api.base + 'actionplan/DeleteCloneActionPlan?actionPlanId='+actionPlanId,{});
  }
  
}
